/**
 * The below file is the Flood Freeze Report service which contains method for doing the API calls.
 * @author: vishal.mishra@velsof.com
 * @date : 29-09-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Flood_State_Report_Create_Freeze,
  Multipart_Form_Data,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const FloodFreezeReportServices = {};

//#region Method for Flood Freeze Report listing page.

/**
 * Method for getting the Flood Freeze Report listing
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
FloodFreezeReportServices.getAll = function (param) {
  return fetch({
    url: Flood_State_Report_Create_Freeze,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    params: param,
  });
};

//#region Method for Flood Freeze Report .

/**
 * Method for importing the Flood Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
FloodFreezeReportServices.create = function (data) {
  return fetch({
    url: Flood_State_Report_Create_Freeze,
    method: "post",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Flood Freeze Report .

/**
 * Method for importing the Flood Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
FloodFreezeReportServices.update = function (data, id) {
  return fetch({
    url: Flood_State_Report_Create_Freeze + `/${id}`,
    method: "put",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Flood Freeze Report .

export default FloodFreezeReportServices;
